import i18n from '@/i18n'
import Store from '@/store'
import pdfMake from 'pdfmake/build/pdfmake'
import ReportHeading from '@/Utils/report-head-awareness'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'
// import { dateFormat } from '@/Utils/fliter'

const exportPdfDetails = async (reportTitle, data, vm, awarenessEventServiceBaseUrl, baseUrl, uri, orgId, deviceList, deviceRemainingQuantity, centers) => {
  try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
        pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)
      const pdfContent = [
          {
            columns: reportHeadData.reportHeadColumn
          },
          { text: reportHeadData.orgName, style: 'orgName', alignment: 'center' },
          { text: reportHeadData.address, style: 'address', alignment: 'center' }
        ]
        const allRowsHead = [
          [
            { text: vm.$t('globalTrans.fiscal_year') + ' : ' + (i18n.locale === 'bn' ? data.fiscal_year_bn : data.fiscal_year_en), alignment: 'left', style: 'th' },
            { text: vm.$t('assitive_device_management.purchase_order_no') + ' : ' + vm.$n(data.purchase_memo_no, { useGrouping: false }), alignment: 'left', style: 'th' },
            { text: '' + '' + '', alignment: 'left', style: 'th' }
          ]
        ]
        var datafirstdummy = null
        var datafirst = [{ text: vm.$t('hospital_information.sl'), rowSpan: 4 }, { text: vm.$t('assitive_device_management.idsc_center'), rowSpan: 4 }]
        var i = 0
        for (i = 0; i < deviceList.length; i++) {
          if (i === 0) {
            datafirstdummy = { text: vm.$t('assitive_device_management.assign_quantity'), colSpan: deviceList.length, alignment: 'center' }
            datafirst.push(datafirstdummy)
          } else {
            datafirst.push({ text: vm.$t('child_admission_management.reason') })
          }
        }
        var datasecond = [{ text: vm.$t('hospital_information.sl') }, { text: vm.$t('assitive_device_management.idsc_center') }]
        for (i = 0; i < deviceList.length; i++) {
          if (i18n.locale === 'bn') {
            datasecond.push({ text: deviceList[i].device_name_bn, alignment: 'center' })
          } else {
            datasecond.push({ text: deviceList[i].device_name, alignment: 'center' })
          }
        }
        var datathird = [{ text: vm.$t('hospital_information.sl') }, { text: vm.$t('assitive_device_management.idsc_center') }]
        for (i = 0; i < deviceList.length; i++) {
          datathird.push({ text: vm.$t('sitePreference.total') + ':' + deviceList[i].purchase_quantity, alignment: 'center' })
        }
        var datafourth = [{ text: vm.$t('hospital_information.sl') }, { text: vm.$t('assitive_device_management.idsc_center') }]
        for (i = 0; i < deviceList.length; i++) {
          datafourth.push({ text: vm.$t('assitive_device_management.remaining') + ':' + deviceRemainingQuantity[deviceList[i].assistive_device_id], alignment: 'center' })
        }
        var rowData = [
          datafirst,
          datasecond,
          datathird,
          datafourth
        ]
        var k = 0
        var j = 0
        // var inloopdata = null
          var loopdatalast = null
          // centers.map((obj, index) => {
          for (k = 0; k < centers.length; k++) {
            if (i18n.locale === 'bn') {
              loopdatalast = [vm.$n(k + 1), centers[k].center_name_bn]
            } else {
              loopdatalast = [vm.$n(k + 1), centers[k].center_name]
            }
          try {
            if (centers[k].devices !== undefined) {
              for (j = 0; j < centers[k].devices.length; j++) {
                // loopdatalast.push({ text: '1' })
                loopdatalast.push({ text: centers[k].devices[j].quantity })
              }
            } else {
              for (j = 0; j < deviceList.length; j++) {
                loopdatalast.push({ text: '' })
              }
            }
          } catch (e) {
          }
          rowData.push(loopdatalast)
          // inloopdata = []
        }
        // })
      //   if (i18n.locale === 'bn') {
      //   deviceList.map((obj, index) => {
      //     rowData.push([vm.$n(index + 1), 'obj.assistivedeviceName', vm.$n(obj.no_of_quantity, { useGrouping: false }), obj.reason_en])
      //   })
      // } else {
      //   deviceList.map((obj, index) => {
      //     rowData.push([vm.$n(index + 1), 'obj.assistivedeviceName', vm.$n(obj.no_of_quantity, { useGrouping: false }), obj.reason_bn])
      //   })
      // }
      let n = 0
      const widthsFor = []
      for (n = 0; n < centers[0].devices.length * 2; n++) {
         widthsFor.push('*')
      }
        var firstRows =
        [
          {
          style: 'tableExampleMar',
          table:
            {
              widths: widthsFor,
              // keepWithHeaderRows: 1,
              body: rowData
            }
          }
        ]
        pdfContent.push({ text: reportTitle, style: 'header2', alignment: 'center' })
        pdfContent.push({
          style: 'tableExampleMar',
          table: {
            headerRows: 1,
            widths: '*',
            body: allRowsHead
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })
        pdfContent.push(firstRows)
        //   var rowData = [
        //     [{ text: vm.$t('hospital_information.sl') }, { text: vm.$t('assitive_device_management.assistive_device_name') }, { text: vm.$t('assitive_device_management.requisition_quantity') }, { text: vm.$t('assitive_device_management.funding_quantity') }, { text: vm.$t('assitive_device_management.unit_price') }, { text: vm.$t('sitePreference.total') }]
        //   ]
        //    if (i18n.locale === 'bn') {
        //   funddetails.map((obj, index) => {
        //     rowData.push([vm.$n(index + 1), obj.assistiveDeviceName_bn, vm.$n(obj.requisition_quantity, { useGrouping: false }), vm.$n(obj.funding_quantity, { useGrouping: false }), vm.$n(obj.unit_price, { useGrouping: false }), vm.$n(obj.total_price, { useGrouping: false })])
        //   })
        //     } else {
        //    funddetails.map((obj, index) => {
        //      rowData.push([vm.$n(index + 1), obj.assistivedeviceName_en, obj.requisition_quantity, obj.funding_quantity, obj.unit_price, obj.total_price])
        //    })
        //    }
        //   var firstRows =
        //   [
        //     {
        //     style: 'tableExampleMar',
        //     table:
        //       {
        //         widths: ['*', '*', '*', '*', '*', '*'],
        //         // keepWithHeaderRows: 1,
        //         body: rowData
        //       }
        //     }
        //   ]
        // pdfContent.push(firstRows)
        const waterMarkText = i18n.locale === 'bn' ? 'সমাজকল্যাণ মন্ত্রণালয়' : 'Ministry of Social Welfare'
        var docDefinition = {
        content: pdfContent,
        pageSize: 'A4',
        pageOrientation: 'portable',
        watermark: { text: waterMarkText, color: 'blue', opacity: 0.1, bold: true, italics: false },
        styles: {
          th: {
            fontSize: (i18n.locale === 'bn') ? 10 : 9,
            margin: [3, 3, 3, 3]
          },
            th1: {
                fontSize: 9
            },
            td: {
                fontSize: (i18n.locale === 'bn') ? 10 : 9,
                margin: [3, 3, 3, 3]
            },
            td1: {
              fontSize: (i18n.locale === 'bn') ? 8 : 7,
              margin: [3, 3, 3, 3]
            },
            design: {
              margin: [53, 3, 50, 3]
            },
            search: {
              fontSize: (i18n.locale === 'bn') ? 10 : 8,
              margin: [3, 3, 3, 3]
            },
            searchextra: {
              fontSize: (i18n.locale === 'bn') ? 15 : 13,
              margin: [3, 3, 3, 3]
            },
            searchtwo: {
              fontSize: (i18n.locale === 'bn') ? 10 : 8,
              margin: [63, 13, 13, 13]
            },
            fertilizer: {
              margin: [5, 0, 0, 5]
            },
            header: {
              fontSize: 12,
              margin: [0, 0, 0, 4]
            },
            header2: {
              fontSize: 14,
              margin: [0, 10, 0, 20]
            },
            headerPort1: {
              fontSize: 10,
              margin: [0, 20, 0, 5]
            },
            headerPort: {
              fontSize: 10,
              margin: [0, 4, 0, 15]
            },
            krishi: {
              margin: [0, -5, 0, 15],
              alignment: 'center'
            },
            header3: {
              fontSize: 9,
              margin: [0, 0, 0, 0]
            },
            govt_info: {
              margin: [0, 3, 0, 0],
              fontSize: 15,
              alignment: 'center'
            },
            address: {
              fontSize: 9,
              margin: [10, 0, 0, 0]
            },
            tdtwo: {
              fontSize: 10,
              margin: [0, 0, 0, 0]
            },
            td2: {
                border: 0,
                fontSize: 13,
                alignment: 'center'
              },
            AddressTable: {
              margin: [0, 0, 250, 0]
            },
            tableHeader: {
              fontSize: 11
            },
            noborder: {
               border: 0
            },
            left_logo: {
              borderRadius: 50
            },
            mainName: {
              margin: [8, 0, 0, 20]
            },
            tableExample: {
              fontSize: 11,
              margin: [0, 10, 10, 10]
            },
            tableExampleMar: {
              fontSize: 11,
              margin: [10, 50, 10, 10]
            }
          }
        }
        pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {}
    }
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
